import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as MuiSkeleton, } from '@mui/material';
export function Skeleton({ ...props }) {
    return (_jsx(MuiSkeleton, { ...props, sx: {
            borderRadius: '8px',
        }, animation: "wave" }));
}
